import { Data, Model, Utils } from "@singularsystems/neo-core";
import { AxiosPromise } from "axios";
import { injectable } from "inversify";
import { AppService, Types } from "../../App/Services/AppService";
import FileGroupingExportFileSpecSearchCriteria from "../ExportFileGroupingFileSpecs/Models/Queries/FileGroupingExportFileSpecSearchCriteria";
import FileGroupingExportFileSpecLookup from "../ExportFileGroupingFileSpecs/Models/Lookups/FileGroupingExportFileSpecLookup";
import CreateStaticFileGroupingExportFileSpecCommand from "../ExportFileGroupingFileSpecs/Models/Commands/CreateStaticFileGroupingExportFileSpecCommand";
import UpdateStaticFileGroupingExportFileSpecCommand from "../ExportFileGroupingFileSpecs/Models/Commands/UpdateStaticFileGroupingExportFileSpecCommand";
import CommandResult from "../../Common/Models/CommandResult";

export interface IFileGroupingExportFileSpecApiClient {
    getFileGroupingExportFileSpecs(payload: Model.PartialPlainNonTrackedObject<Data.PageRequest<FileGroupingExportFileSpecSearchCriteria>>): AxiosPromise<Data.PageResult<Model.PlainObject<FileGroupingExportFileSpecLookup>>>;
    addNewFileGroupingExportFileSpec(command: Model.PlainObject<CreateStaticFileGroupingExportFileSpecCommand>): AxiosPromise<Model.PlainObject<CommandResult>>;
    updateFileGroupingExportFileSpec(command: Model.PlainObject<UpdateStaticFileGroupingExportFileSpecCommand>): AxiosPromise<Model.PlainObject<CommandResult>>;
}

@injectable()
export default class FileGroupingExportFileSpecApiClient extends Data.ApiClientBase implements IFileGroupingExportFileSpecApiClient {

    constructor(config = AppService.get(Types.Config)) {
        super(`${config.apiPath}/StaticServiceProviderFileGroupingsExportFileSpec`)
    }

    public getFileGroupingExportFileSpecs(payload: Model.PartialPlainNonTrackedObject<Data.PageRequest<FileGroupingExportFileSpecSearchCriteria>>): AxiosPromise<Data.PageResult<Model.PlainObject<FileGroupingExportFileSpecLookup>>> {
        return this.axios.get(`${this.apiPath}/GetFileGroupingExportFileSpecsPagedList?${Utils.getQueryString(payload)}`);
    }

    public addNewFileGroupingExportFileSpec(command: Model.PlainObject<CreateStaticFileGroupingExportFileSpecCommand>): AxiosPromise<Model.PlainObject<CommandResult>> {
        return this.axios.post(`${this.apiPath}/AddNewFileGroupingExportFileSpec`, command);
    }

    public updateFileGroupingExportFileSpec(command: Model.PlainObject<UpdateStaticFileGroupingExportFileSpecCommand>): AxiosPromise<Model.PlainObject<CommandResult>> {
        return this.axios.post(`${this.apiPath}/UpdateFileGroupingExportFileSpec`, command);
    }
}